import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progres-status',
    templateUrl: './progres-status.component.html',
    styleUrls: ['./progres-status.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgresStatusComponent implements OnInit {

  @Input() colors: any;

  constructor() { }

  ngOnInit(): void {
  }
}
